import { ValidationErrors } from '@angular/forms';

import { TranslateService } from '@ngx-translate/core';

interface MaxLengthError {
  requiredLength: number;
  actualLength: number;
}

export function TranslatedErrors(
  translate: TranslateService
): ValidationErrors {
  return {
    required: (): string => translate.instant('errorTailor.required') as string,
    maxlength: ({ requiredLength }: MaxLengthError): string =>
      translate.instant('errorTailor.maxLength', {
        requiredLength,
      }) as string,
    minlength: ({ requiredLength }: MaxLengthError): string =>
      translate.instant('errorTailor.minLength', {
        requiredLength,
      }) as string,
    requiredPhone: (): string =>
      translate.instant('errorTailor.requiredPhone') as string,
    requiredDni: (): string =>
      translate.instant('errorTailor.requiredDni') as string,
    formatVat: (): string =>
      translate.instant('errorTailor.vatErrorFormatVies') as string,
    requiredEmail: (): string =>
      translate.instant('errorTailor.requiredEmail') as string,
    requiredSignPlate: (): string =>
      translate.instant('errorTailor.requiredSignPlate') as string,
    requiredPropulsion: (): string =>
      translate.instant('errorTailor.required') as string,
    email: (): string => translate.instant('errorTailor.email') as string,
    /*invalidNameDni: (): string =>
      translate.instant('errorTailor.invalidNameDni') as string,*/
  };
}
